<template>
    <div class="nevs-content" v-if="message != null">
        <div class="nevs-content-top-buttons">
            <span v-if="!message.seen"><NevsButton class="success help-save" @click="markAsSeenClick()"><i class="fa-solid fa-eye"></i>
                {{ $LANG.Get('buttons.markMessageAsSeen') }}
            </NevsButton>&nbsp;</span>
            <NevsButton class="error help-back" @click="backClick"><i class="fa-solid fa-arrow-left"></i> {{
                    $LANG.Get('buttons.back')
                }}
            </NevsButton>
        </div>
        <div class="unseen-disclaimer" v-if="!message.seen">
            {{ $LANG.Get('labels.unseenMessageDisclaimer') }}
        </div>
        <div class="message">
            <div class="message-title">{{ message.title }}</div>
            <div class="message-time">{{ message.time_display }}</div>
            <div class="message-content" v-html="message.content"></div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";

export default {
    name: "EntityMessage",
    components: { NevsButton },
    data() {
        return {
            messageId: this.$route.params.id,
            message: null
        }
    },
    methods: {
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        markAsSeenClick()
        {
            let vm = this;
            this.$API.APICall('post', 'messages/see/' + this.messageId, {}, (data, success) => {
                if (success) {
                    vm.$CROSS_TAB_BUS.TriggerEvent('check-messages', {});
                    vm.backClick();
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'null');
        this.$store.commit('selectSubMenu', 'null');

        let vm = this;
        this.$API.APICall('get', 'messages/' + this.messageId, {}, (data, success) => {
            if (success) {
                vm.message = data.message;
            }
        });
    }
}
</script>

<style scoped>

.message {
    margin-top: 20px;
}

.message-title {
    font-size: 25px;
    font-weight: bold;
    border-bottom: 2px solid grey;
}

.message-time {
    margin-bottom: 10px;
    font-style: italic;
}

.unseen-disclaimer {
    font-size: 12px;
}

</style>